module.exports = __webpack_public_path__ + "img/Logo_MII_home.8fd49252.png";